import { DestinationStandardMapping } from "../types";

const adrollStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [],
};

// TODO: Hit Adroll API and get customer's campaigns
export const getAdrollStandardMapping = async () => {
  return adrollStandardMapping;
};
